export default __webpack_public_path__ + "static/media/super.f450fb12.png";